(() => {
  if (window.__lukzerFestivePopupInitialized) return;
  window.__lukzerFestivePopupInitialized = true;
  const key = 'lukzer_festive_popup_dismissed_at_v2';
  let memoryDismissedAt = 0;
  let active = null;
  let previouslyFocused = null;
  let previousOverflow = '';
  let inertBackground = [];

  function init(root = document) {
    const popup = root.querySelector('[data-lukzer-festive-popup]');
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';
    popup.style.setProperty('--lukzer-popup-width', `${Number(popup.dataset.width) || 460}px`);
    popup.style.setProperty('--lukzer-popup-mobile-width', `${Math.min(100, Number(popup.dataset.mobileWidth) || 90)}vw`);
    popup.style.setProperty('--lukzer-popup-opacity', String(Math.min(100, Number(popup.dataset.opacity) || 65) / 100));
    const dialog = popup.querySelector('.lukzer-festive-popup__dialog');
    const close = popup.querySelector('[data-popup-close]');
    let dismissing = false;
    let stopCelebration = () => {};
    const inEditor = popup.dataset.editorPreview === 'true';
    const forcePreview = new URLSearchParams(window.location.search).get('lukzer_festive_popup_preview') === '1';
    const readDismissed = () => {
      try { return Number(localStorage.getItem(key)) || memoryDismissedAt; }
      catch (_) { return memoryDismissedAt; }
    };
    const rememberDismissal = () => {
      memoryDismissedAt = Date.now();
      try { localStorage.setItem(key, String(memoryDismissedAt)); } catch (_) { /* memory fallback */ }
    };

    const startCelebration = () => {
      if (popup.dataset.celebration !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      popup.classList.add('is-celebrating');
      stopCelebration = () => popup.classList.remove('is-celebrating');

      const fireworksEnabled = popup.dataset.fireworks === 'true';
      const sparklesEnabled = popup.dataset.sparkles === 'true';
      if (!fireworksEnabled && !sparklesEnabled) return;

      const canvas = document.createElement('canvas');
      canvas.className = 'lukzer-festive-popup__celebration';
      canvas.setAttribute('aria-hidden', 'true');
      dialog.prepend(canvas);
      const context = canvas.getContext('2d', { alpha: true });
      if (!context) { canvas.remove(); return; }

      const intensity = popup.dataset.intensity || 'medium';
      const mobile = matchMedia('(max-width: 767px)').matches;
      const settings = intensity === 'low'
        ? { bursts: 4, sparks: 14, sparkles: 8 }
        : intensity === 'high'
          ? { bursts: 10, sparks: 28, sparkles: 22 }
          : { bursts: 6, sparks: 20, sparkles: 15 };
      if (mobile) {
        settings.sparks = Math.max(8, Math.round(settings.sparks * .55));
        settings.sparkles = Math.max(5, Math.round(settings.sparkles * .6));
        settings.bursts = Math.max(3, Math.round(settings.bursts * .7));
      }
      const duration = Math.min(6, Math.max(1, Number(popup.dataset.fireworkDuration) || 3)) * 1000;
      const image = popup.querySelector('.lukzer-festive-popup__image');
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      let canvasRect;
      let imageRect;
      let animationFrame = 0;
      let startedAt = 0;
      let pausedAt = 0;
      let nextBurst = 0;
      let disposed = false;
      const particles = [];
      const sparkles = [];
      const colors = ['#ffe08a', '#ffc247', '#e9a52f', '#c94432'];

      const resizeCanvas = () => {
        canvasRect = canvas.getBoundingClientRect();
        imageRect = image.getBoundingClientRect();
        canvas.width = Math.max(1, Math.round(canvasRect.width * dpr));
        canvas.height = Math.max(1, Math.round(canvasRect.height * dpr));
        context.setTransform(dpr, 0, 0, dpr, 0, 0);
      };
      const outsidePoint = () => {
        const side = Math.floor(Math.random() * 4);
        const pad = 5 + Math.random() * 35;
        if (side === 0) return { x: Math.random() * canvasRect.width, y: Math.max(1, imageRect.top - canvasRect.top - pad) };
        if (side === 1) return { x: Math.random() * canvasRect.width, y: Math.min(canvasRect.height - 1, imageRect.bottom - canvasRect.top + pad) };
        if (side === 2) return { x: Math.max(1, imageRect.left - canvasRect.left - pad), y: Math.random() * canvasRect.height };
        return { x: Math.min(canvasRect.width - 1, imageRect.right - canvasRect.left + pad), y: Math.random() * canvasRect.height };
      };
      const burstPoint = (index) => {
        const positions = [0.13, 0.13, 0.5, 0.5, 0.86, 0.86];
        const right = index % 2 === 1;
        return {
          x: (right ? imageRect.right : imageRect.left) - canvasRect.left + (right ? 22 : -22),
          y: imageRect.top + imageRect.height * positions[index % positions.length] - canvasRect.top
        };
      };
      const launchBurst = (index, elapsed) => {
        const origin = burstPoint(index);
        for (let i = 0; i < settings.sparks; i += 1) {
          const angle = (Math.PI * 2 * i / settings.sparks) + Math.random() * .12;
          const speed = 54 + Math.random() * 78;
          particles.push({
            x: origin.x, y: origin.y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            age: 0, life: Math.min(750 + Math.random() * 500, Math.max(100, duration - elapsed)),
            radius: 1.6 + Math.random() * 1.8,
            color: colors[Math.floor(Math.random() * colors.length)]
          });
        }
      };
      const resetSparkle = (sparkle) => {
        const point = outsidePoint();
        sparkle.x = point.x;
        sparkle.y = point.y;
        sparkle.age = 0;
        sparkle.life = 1400 + Math.random() * 1800;
        sparkle.vx = (Math.random() - .5) * (mobile ? 6 : 9);
        sparkle.vy = -3 - Math.random() * (mobile ? 7 : 10);
        sparkle.radius = .9 + Math.random() * (mobile ? .9 : 1.4);
      };

      resizeCanvas();
      if (sparklesEnabled) {
        for (let i = 0; i < settings.sparkles; i += 1) {
          const sparkle = {};
          resetSparkle(sparkle);
          sparkle.age = Math.random() * sparkle.life;
          sparkles.push(sparkle);
        }
      }

      const removeCanvasAndListeners = () => {
        if (disposed) return;
        disposed = true;
        if (animationFrame) cancelAnimationFrame(animationFrame);
        document.removeEventListener('visibilitychange', handleVisibility);
        window.removeEventListener('resize', resizeCanvas);
        canvas.remove();
      };
      const cancel = () => {
        removeCanvasAndListeners();
        popup.classList.remove('is-celebrating');
      };
      stopCelebration = cancel;

      const draw = (now) => {
        if (disposed) return;
        const elapsed = now - startedAt;
        const step = 1 / 60;
        context.clearRect(0, 0, canvasRect.width, canvasRect.height);

        if (fireworksEnabled && elapsed < duration) {
          while (nextBurst < settings.bursts && elapsed >= duration * (nextBurst / settings.bursts) * .75) {
            launchBurst(nextBurst, elapsed);
            nextBurst += 1;
          }
          for (let i = particles.length - 1; i >= 0; i -= 1) {
            const particle = particles[i];
            particle.age += step * 1000;
            if (particle.age >= particle.life) { particles.splice(i, 1); continue; }
            particle.x += particle.vx * step;
            particle.y += particle.vy * step + 9 * step;
            const alpha = 1 - particle.age / particle.life;
            context.globalAlpha = alpha;
            context.fillStyle = particle.color;
            context.shadowColor = particle.color;
            context.shadowBlur = 7;
            context.strokeStyle = particle.color;
            context.lineWidth = particle.radius;
            context.beginPath();
            context.moveTo(particle.x, particle.y);
            context.lineTo(particle.x - particle.vx * .075, particle.y - particle.vy * .075);
            context.stroke();
            context.shadowBlur = 0;
          }
        }

        if (sparklesEnabled) {
          const visibleSparkles = elapsed < duration ? sparkles.length : Math.max(4, Math.ceil(sparkles.length * .55));
          for (let i = 0; i < visibleSparkles; i += 1) {
            const sparkle = sparkles[i];
            sparkle.age += step * 1000;
            if (sparkle.age >= sparkle.life) resetSparkle(sparkle);
            sparkle.x += sparkle.vx * step;
            sparkle.y += sparkle.vy * step;
            const fadeIn = Math.min(1, sparkle.age / 180);
            const fadeOut = Math.min(1, (sparkle.life - sparkle.age) / 420);
            context.globalAlpha = (elapsed < duration ? .82 : .38) * fadeIn * fadeOut;
            context.fillStyle = '#ffd879';
            context.beginPath();
            context.arc(sparkle.x, sparkle.y, sparkle.radius, 0, Math.PI * 2);
            context.fill();
          }
        }
        context.globalAlpha = 1;
        if ((fireworksEnabled && elapsed < duration) || sparklesEnabled) animationFrame = requestAnimationFrame(draw);
        else {
          removeCanvasAndListeners();
          stopCelebration = () => popup.classList.remove('is-celebrating');
        }
      };
      function handleVisibility() {
        if (document.hidden) {
          if (!pausedAt) pausedAt = performance.now();
          if (animationFrame) cancelAnimationFrame(animationFrame);
          animationFrame = 0;
        } else if (pausedAt) {
          startedAt += performance.now() - pausedAt;
          pausedAt = 0;
          animationFrame = requestAnimationFrame(draw);
        }
      }

      document.addEventListener('visibilitychange', handleVisibility);
      window.addEventListener('resize', resizeCanvas, { passive: true });
      startedAt = performance.now();
      if (!document.hidden) animationFrame = requestAnimationFrame(draw);
      else pausedAt = startedAt;
    };

    const open = () => {
      if (active && active !== popup) return;
      active = popup;
      previouslyFocused = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      inertBackground = [...document.body.children]
        .filter((element) => element !== popup)
        .map((element) => ({ element, wasInert: element.inert }));
      inertBackground.forEach(({ element }) => { element.inert = true; });
      document.documentElement.style.overflow = 'hidden';
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        close.focus();
        requestAnimationFrame(startCelebration);
      });
    };
    const dismiss = () => {
      if (dismissing || popup.hidden) return;
      dismissing = true;
      if (!inEditor && !forcePreview) rememberDismissal();
      stopCelebration();
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = previousOverflow;
      inertBackground.forEach(({ element, wasInert }) => { element.inert = wasInert; });
      inertBackground = [];
      active = null;
      const finish = () => {
        popup.hidden = true;
        dismissing = false;
        if (previouslyFocused && previouslyFocused.isConnected) previouslyFocused.focus();
      };
      if (popup.dataset.animation === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else window.setTimeout(finish, 450);
    };

    close.addEventListener('click', dismiss);
    popup.querySelector('[data-popup-overlay]').addEventListener('click', (event) => {
      if (event.target === event.currentTarget && popup.dataset.clickOutside === 'true') dismiss();
    });
    document.addEventListener('keydown', (event) => {
      if (active !== popup) return;
      if (event.key === 'Escape') { event.preventDefault(); dismiss(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]')];
      if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
      if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
    });
    if (inEditor || forcePreview) {
      document.addEventListener('shopify:section:load', () => { if (!popup.hidden) return; open(); }, { once: true });
      open();
      return;
    }
    if (Date.now() - readDismissed() < (Number(popup.dataset.cooldown) || 24) * 60 * 60 * 1000) return;
    window.setTimeout(open, Math.max(0, Number(popup.dataset.delay) || 1200));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
